import React from "react";
// import bgImg from "../../assets/Rectangle05.png";
// import dpImg from "../../assets/2bg 1.png";
import COLORS from '../constants/colors';
 
const cards = [
  {
    number: "01",
    text: <span style={{ color: COLORS.buttonColor }}>
    Educate the public<span className = "text-[#757575]"> about ongoing lawsuits and legal rights</span>
    </span>,
    bg: "bg-[#FFFFFF]",
  },
  {
    number: "02",
    text: <span style={{ color: COLORS.buttonColor }}>
    <span className = "text-[#757575]">Provide </span>free, no-obligation<span className = "text-[#757575]"> case evaluations</span>
    </span>,
    bg: "bg-[#FFFFFF]",
  },
  {
    number: "03",
    text: <span style={{ color: COLORS.buttonColor }}>
    Connect qualified individuals<span className = "text-[#757575]"> with experienced attorneys</span>
    </span>,
    bg: "bg-[#FFFFFF]",
  },
  {
    number: "04",
    text: <span style={{ color: COLORS.buttonColor }}>
        <span className = "text-[#757575]">Offer a </span>safe, private process<span className = "text-[#757575]"> to start your legal journey</span>
    </span>,
    bg: "bg-[#FFFFFF]",
  },
  
];
 
const AboutThree = () => {
  const [is1024, setIs1024] = React.useState(false);
 
  React.useEffect(() => {
    const checkWidth = () => {
      setIs1024(window.innerWidth === 1024);
    };
    checkWidth();
    window.addEventListener("resize", checkWidth);
    return () => window.removeEventListener("resize", checkWidth);
  }, []);
 
  return (
    <section
      className={`w-full font-[Quicksand] bg-cover bg-center bg-no-repeat`}
      //style={{ backgroundImage: `url(${bgImg})` }}
      style={{ backgroundColor: COLORS.primaryBlue }}
    >
      {/*  Desktop + Tablet Layout (≥768px) */}
      <div className="hidden md:block w-full">
        <div className="w-full max-w-[1440px] mx-auto px-[80px] py-[60px]">
          {/* Main Heading - Dual Color */}
          <h2 className="mb-6">
            <span style={{ color: COLORS.whiteColor }} className="font-[Quicksand] font-bold text-[28px] leading-[35px] max-w-[85vw] md:text-[32px] md:leading-[38px] md:max-w-[50vw] lg:text-[36px] lg:leading-[42px] lg:max-w-[45vw] xl:text-[48px] xl:leading-[56px] xl:max-w-[568px] 2xl:text-[56px] 2xl:leading-[64px] 2xl:max-w-[680px] min-[3840px]:text-[72px] min-[3840px]:leading-[80px] min-[3840px]:max-w-[1136px] capitalize overflow-hidden text-ellipsis">
              What{" "}
            </span>
            <span style={{ color: COLORS.yellow }} className="font-[Quicksand] font-bold text-[28px] leading-[35px] max-w-[85vw] md:text-[32px] md:leading-[38px] md:max-w-[50vw] lg:text-[36px] lg:leading-[42px] lg:max-w-[45vw] xl:text-[48px] xl:leading-[56px] xl:max-w-[568px] 2xl:text-[56px] 2xl:leading-[64px] 2xl:max-w-[680px] min-[3840px]:text-[72px] min-[3840px]:leading-[80px] min-[3840px]:max-w-[1136px] capitalize overflow-hidden text-ellipsis">
              We Do
            </span>
          </h2>
 
          
 
        
{/* Cards Container */}
          <div className="grid grid-cols-2 gap-8">
            {cards.map((card) => (
              <article
                key={card.number}
                className={`p-4 h-[100px] rounded-[10px] ${card.bg} shadow-sm border border-white overflow-hidden flex flex-col justify-center `}
              >
                <span style={{ color: COLORS.primaryBlue }} className="font-[Quicksand] font-bold leading-none text-[24px] mb-2">
                  {card.number}
                </span>
                <p style={{ color: COLORS.primaryBlue }} className="font-[Quicksand] text-[8px] leading-[8px] max-w-[318px] md:text-[10px] md:leading-[12px] md:max-w-[368px] lg:text-[12px] lg:leading-[14px] lg:max-w-[490px] xl:text-[16px] xl:leading-[22px] xl:max-w-[650px] 2xl:text-[20px] 2xl:leading-[25px] 2xl:max-w-[680px] min-[3840px]:text-[36px] min-[3840px]:leading-[40px] min-[3840px]:max-w-[1510px] tracking-[-0.32px] text-left">
                  {card.text}
                </p>
              </article>
            ))}
          </div>
 
 
        </div>
      </div>
 
      {/*  Mobile Layout (<768px) */}
      <div className="md:hidden flex flex-col w-full gap-6 px-4 py-10">
        {/* Mobile Main Heading */}
        <h2 className="text-left font-[Quicksand] font-bold text-[24px] leading-normal capitalize">
          <span style={{ color: COLORS.primaryBlue }}>
            What{" "}
          </span>
 
          <span style={{ color: COLORS.yellow }}>
            We Do
          </span>
        </h2>
 
        {/* Mobile Cards */}
        <div  className="flex flex-col gap-4">
          {cards.map((card) => (
            <div
              key={card.number}
              className="w-full bg-white rounded-[10px] border border-white p-4 shadow-sm text-left"
            >
              <span style={{ color: COLORS.primaryBlue }} className="font-[Quicksand] font-bold leading-normal mb-2 block text-[20px]">
                {card.number}
              </span>
              <p style={{ color: COLORS.primaryBlue }} className="font-[Quicksand] text-[15px] leading-normal">
                {card.text}
              </p>
            </div>
          ))}
        </div>
        
      </div>
    </section>
  );
};
 
export default AboutThree;
 
 